import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faAngleRight,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRotateLeft,
  faArrowUp,
  faBan,
  faCircleDollar,
  faCircleInfo,
  faDoorOpen,
  faEllipsisVertical,
  faEquals,
  faExternalLink,
  faLock,
  faLockKeyhole,
  faMapPin,
  faMinus,
  faPaperPlane,
  faStar,
  faStars,
  faThumbsUp,
  faTriangleExclamation,
  faVrCardboard,
  faXmark,
} from "@fortawesome/pro-regular-svg-icons";

export const initRegularIcons = () => {
  library.add(
    faAngleRight,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowRotateLeft,
    faArrowUp,
    faBan,
    faCircleDollar,
    faCircleInfo,
    faDoorOpen,
    faEllipsisVertical,
    faEquals,
    faExternalLink,
    faLock,
    faLockKeyhole,
    faMapPin,
    faMinus,
    faPaperPlane,
    faStar,
    faStars,
    faThumbsUp,
    faTriangleExclamation,
    faVrCardboard,
    faXmark,
  );
};
